import Flickity from "flickity";

const SELECTORS = {
  blockweeksblock: '#block-weeksblock .moments__week-block--list'
}

window.Drupal.behaviors.blockWeeksblock = {
  attach: (context) => {
    const ins = {}
    let screenWidth = screen.width;
    if (screenWidth < 992) {
      for (const instance in SELECTORS) {
        ins[instance] = [...context.querySelectorAll(SELECTORS[instance])]
        if (ins[instance].length) {
          for (const component of ins[instance]) {
            if (component.children.length > 1) {
              const flickity = new Flickity(component, {
                cellAlign: "left",
                wrapAround: true,
                lazyLoad: true,
                contain: true,
                pageDots: true,
                adaptiveHeight: true,
                imagesLoaded: true,
              });
            }
          }
        }
      }
    }
  }
}
